import Fab from '@material-ui/core/Fab';
import KioskLog from 'models/KioskLog';
import LoginButton from '@material-ui/icons/ArrowForward';
import PropTypes from 'prop-types';
import React from 'react';
import throttle from 'lodash.throttle';
import { actions as brandInfoActions } from 'redux/domain/BrandInfo';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import { IMAGES_SMALL, IMAGES_MEDIUM, IMAGES_LARGE, getImages } from 'shared/utils/imagesHelpers';
import { Link } from 'react-router-dom';
import { withTheme } from '@material-ui/core/styles';
import styles from './styles.css';

require('react-image-gallery/styles/scss/image-gallery.scss');

class FeaturedImage extends React.Component {
	constructor() {
		super();
		this.state = {
			featuredImage: '',
			fadeImage: '',
			showFadeImage: false,
			imageSize: '',
		};
		this.handleResize = throttle(this.handleResize.bind(this), 300);
	}

	componentDidMount() {
		// select image with closest aspect ratio
		this.handleResize();
		// Support resize for better image display
		window.addEventListener('resize', this.handleResize);
		// get topics for featured image
		this.getBrandInfoAsync();
	}

	componentWillReceiveProps(nextProps) {
		const { imageSize, featuredImage } = this.state;
		if (nextProps.images.length > 0) {
			const nextImage = getImages(nextProps.images, imageSize)[0].original;
			if (nextImage !== this.state.featuredImage) {
				this.setState({
					fadeImage: featuredImage,
					showFadeImage: true,
					featuredImage: nextImage,
				});
			}
		}
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleResize);
	}

	/**
	 * Get the settings that clients use to customize the kiosk
	 */
	getBrandInfoAsync() {
		const { getBrandInfo } = this.props;
		try {
			getBrandInfo();
		} catch (error) {
			const log = new KioskLog(error);
			log.postMessage();
		}
	}

	/**
	 * Handle the resize event. When the screen resizes, adjust the image
	 */
	handleResize() {
		const windowWidth = window.innerWidth;
		const currentSize = this.state.imageSize;
		const { images } = this.props;
		// set breakpoints based on material ui: https://material-ui-1dab0.firebaseapp.com/layout/basics/
		if (window.innerHeight > windowWidth) {
			// this is portrait
			if (currentSize !== IMAGES_SMALL) {
				if (images.length > 0) {
					this.setState({
						featuredImage: getImages(images, IMAGES_SMALL)[0].original,
						imageSize: IMAGES_SMALL,
					});
				} else {
					this.setState({ imageSize: IMAGES_SMALL });
				}
			}
		} else if (windowWidth >= 1280) {
			if (currentSize !== IMAGES_LARGE) {
				if (images.length > 0) {
					this.setState({
						featuredImage: getImages(images, IMAGES_LARGE)[0].original,
						imageSize: IMAGES_LARGE,
					});
				} else {
					this.setState({ imageSize: IMAGES_LARGE });
				}
			}
		} else if (currentSize !== IMAGES_MEDIUM) {
			if (images.length > 0) {
				this.setState({
					featuredImage: getImages(images, IMAGES_MEDIUM)[0].original,
					imageSize: IMAGES_MEDIUM,
				});
			} else {
				this.setState({ imageSize: IMAGES_MEDIUM });
			}
		}
	}

	render() {
		const { theme } = this.props;
		const { brandInfo, isVisible } = this.props;
		return (
			<div>
				{isVisible ? (
					<div style={{ position: 'absolute', height: '100%', width: '100%' }}>
						<div className={styles['featured-text']}>
							<div style={{ display: 'table-cell', verticalAlign: 'middle' }}>
								{brandInfo.topics === undefined || brandInfo.topics.length === 0 ? null : (
									<div style={{ display: 'table' }}>
										<div className={styles['secondary-text']}>{brandInfo.topics[0].title}</div>
										<div style={{ display: 'table-cell' }}>
											<Link to="/topic/0">
												<Fab
													mini
													style={{ backgroundColor: theme.palette.secondary.main }}
												>
													<LoginButton
														style={{
															color: theme.palette.getContrastText(theme.palette.secondary.main),
														}}
													/>
												</Fab>
											</Link>
										</div>
									</div>
								)}
							</div>
						</div>
						<div
							className={styles['featured-image-overlay']}
							style={{ backgroundColor: theme.palette.background.paper }}
						/>
						<CSSTransition
							timeout={500}
							in={this.state.showFadeImage}
							mountOnEnter
							unmountOnExit
							classNames={{
								exit: styles['featured-image-exit'],
								exitActive: styles['featured-image-exit-active'],
							}}
						>
							<img className={styles['fade-image']} src={this.state.fadeImage} alt="" />
						</CSSTransition>
						{this.state.featuredImage !== '' ? (
							<img
								src={this.state.featuredImage}
								alt="Img"
								className={styles['featured-image']}
								onLoad={() => this.setState({ showFadeImage: false })}
							/>
						) : null}
					</div>
				) : null}
			</div>
		);
	}
}

FeaturedImage.propTypes = {
	brandInfo: PropTypes.shape({
		logo: PropTypes.string,
		topics: PropTypes.arrayOf(PropTypes.object),
	}),
	getBrandInfo: PropTypes.func.isRequired,
	images: PropTypes.arrayOf(PropTypes.object).isRequired,
	isVisible: PropTypes.bool,
	theme: PropTypes.instanceOf(Object).isRequired,
};

FeaturedImage.defaultProps = {
	brandInfo: {
		logo: '',
		topics: [{}],
	},
	isVisible: true,
};

// make state available via props
const mapStateToProps = state => {
	const brandInfo = state.brandInfo.get('brandInfo');
	return {
		brandInfo,
	};
};

// make actions available via props
const mapDispatchToProps = dispatch => bindActionCreators({ ...brandInfoActions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withTheme(FeaturedImage));
